import { cloneDeep } from 'lodash';
import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';
import { WebsiteInfo } from '@/models/website-info.model';

interface WebsiteInfoState {
  websiteInfo: WebsiteInfo | null;
}

export const defaultWebsiteInfoState: WebsiteInfoState = {
  websiteInfo: null
};

const state: WebsiteInfoState = cloneDeep(defaultWebsiteInfoState);

const mutations: MutationTree<WebsiteInfoState> = {
  ADD_WEBSITE_INFO(returnedState: WebsiteInfoState, payload: WebsiteInfo): void {
    returnedState.websiteInfo = payload;
  }
};

const actions: ActionTree<WebsiteInfoState, {}> = {
  addWebsiteInfo: ({ commit }: ActionContext<WebsiteInfoState, {}>, info: WebsiteInfo): void => {
    commit('ADD_WEBSITE_INFO', info);
  }
};

const getters: GetterTree<WebsiteInfoState, {}> = {
  websiteInfo: (returnedState: WebsiteInfoState): WebsiteInfo => {
    return (returnedState?.websiteInfo ?? {}) as WebsiteInfo;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
